<template>
    <div class="text-yanone" v-if="sizesQuantities">
        <template v-if="colors && colors.length > 0">
            <div class="mb">
                <div>
                    <p class="h6">
                        Cor: <strong>{{selectedColor.name}}</strong>
                    </p>
                </div>

                <nav class="cr-option-group">
                    <div v-for="color in colors"
                         class="cr-option cr-option-rounded"
                         :class="{'cr-option-selected': selectedColor === color}"
                         style="background-color: white; padding: 2px"
                         @click="setColor(color)">
                        <div :style="{'background-color': color.code}"
                             class="product-color-option"></div>
                    </div>
                </nav>
            </div>
        </template>

        <div id="product-wholesaler-modelings" v-if="modelings && modelings.length > 0">
            <div class="text-center hidden-md-up mb-4 mt">
                <hr/>
                <span class="h3 text-bold">
                    Modelagens
                </span>
                <span class="text-accent cursor-pointer text-underline"
                      @click="$emit('show-sizes-table')">
                    Ver medidas
                </span>
            </div>

            <div class="d-flex flex-align-center product-wholesaler-modeling hidden-md-down">
                <div class="h5">
                    <span class="text-bold">
                        Modelagens -
                    </span>
                    <span class="text-accent cursor-pointer text-underline"
                          @click="$emit('show-sizes-table')">
                        Ver medidas
                    </span>
                </div>
                <div class="d-flex flex-item-grow">
                    <div class="px text-bold text-center"
                         v-for="size in sizeNames"
                         :style="`flex: 0 0 ${100 / sizeNames.length}%`">
                        <p>{{size}}</p>
                    </div>
                </div>
            </div>

            <div v-for="modeling in modelings"
                 class="d-flex product-wholesaler-modeling mb">
                <div class="h5 mt-2">
                    {{modeling.name}}
                </div>

                <div id="product-wholesaler-sizes" class="flex-item-grow">
                    <div v-for="size in sizes"
                         v-if="modeling.id === size.product_model_id"
                         class="px product-wholesaler-size">
                        <label class="d-block hidden-md-up text-center text-bold mb-2 mt">
                            {{size.size_name}}
                        </label>
                        <ProductWholesalerSizeField
                                v-model="sizesQuantities[size.variation_id]"
                                :key="size.variation_id"
                                :product="product"
                                :size="size"
                                @open-reprint="$emit('open-reprint', $event)"/>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="d-flex flex-spaced-fixed flex-wrap">
            <div v-for="size in sizes"
                 class="flex-child-fixed"
                 style="flex-shrink: 0; flex-basis: 125px">
                <p class="h6 text-bold">
                    {{size.size_name}}
                </p>
                <ProductWholesalerSizeField
                        v-model="sizesQuantities[size.variation_id]"
                        :key="size.variation_id"
                        :product="product"
                        :size="size"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductWholesalerSizes from "./ProductWholesalerSizes";
    import ProductWholesalerSizeField from "./wholesaler/ProductWholesalerSizeField";
    import NumberField from "@bit/chicorei.chicomponents.input.number-field";

    export default {
        extends: ProductWholesalerSizes,

        name: "ProductWholesalerMultipleSizes",

        components: {ProductWholesalerSizeField, NumberField},

        computed: {
            sizeNames() {
                return this.sizes.map(s => s.size_name).filter((s, index, sizes) => index === sizes.indexOf(s));
            }
        }
    }
</script>